import { _ as _defineProperty, g as getValueByPath } from './helpers-d639255d.js';
import { B as BaseComponentMixin, c as config, n as normalizeComponent } from './plugins-4295ce0e.js';
import { _ as __vue_component__$1 } from './Icon-9c764942.js';

/**
 * The classic button, in different colors, sizes, and states
 * @displayName Button
 * @example ./examples/Button.md
 * @style _button.scss
 */

var script = {
  name: 'OButton',
  components: _defineProperty({}, __vue_component__$1.name, __vue_component__$1),
  mixins: [BaseComponentMixin],
  inheritAttrs: false,
  props: {
    /**
    * Color of the control, optional
    * @values primary, info, success, warning, danger, and any other custom color
    */
    variant: [String, Object],

    /**
     * Size of button, optional
     * @values small, medium, large
     */
    size: String,

    /**
     * Button label, optional when default slot
     */
    label: String,

    /**
     * Icon pack to use
     * @values mdi, fa, fas and any other custom icon pack
     */
    iconPack: String,

    /**
     * Icon name to show on the left
     */
    iconLeft: String,

    /**
     * Icon name to show on the right
     */
    iconRight: String,

    /**
     * Rounded style
     */
    rounded: {
      type: Boolean,
      default: function _default() {
        return getValueByPath(config, 'button.rounded', false);
      }
    },

    /**
     * Outlined style
     */
    outlined: Boolean,

    /**
     * Button will be expanded (full-width)	
     */
    expanded: Boolean,
    inverted: Boolean,

    /**
     * Button type, like native
     */
    nativeType: {
      type: String,
      default: 'button',
      validator: function validator(value) {
        return ['button', 'submit', 'reset'].indexOf(value) >= 0;
      }
    },

    /**
     * Button tag name
     * @values button, a, input, router-link, nuxt-link or other nuxt alias
     */
    tag: {
      type: String,
      default: 'button'
    },

    /**
     * Button will be disabled
     */
    disabled: Boolean,

    /**  @ignore */
    iconBoth: Boolean,
    // This is used internally
    rootClass: String,
    outlinedClass: String,
    invertedClass: String,
    expandedClass: String,
    roundedClass: String,
    disabledClass: String,
    sizeClass: String,
    variantClass: String
  },
  computed: {
    rootClasses: function rootClasses() {
      return [this.computedClass('button', 'rootClass', 'o-button'), _defineProperty({}, "".concat(this.computedClass('button', 'sizeClass', 'o-size-')).concat(this.size), this.size), _defineProperty({}, "".concat(this.computedClass('button', 'variantClass', 'o-color-')).concat(this.variant), this.variant), _defineProperty({}, this.computedClass('button', 'outlinedClass', 'o-button-outlined'), this.outlined), _defineProperty({}, this.computedClass('button', 'invertedClass', 'o-button-inverted'), this.inverted), _defineProperty({}, this.computedClass('button', 'expandedClass', 'o-button-expanded'), this.expanded), _defineProperty({}, this.computedClass('button', 'roundedClass', 'o-button-rounded'), this.rounded), _defineProperty({}, this.computedClass('button', 'disabledClass', 'o-button-disabled'), this.disabled)];
    },
    computedTag: function computedTag() {
      if (this.disabled !== undefined && this.disabled !== false) {
        return 'button';
      }

      return this.tag;
    },
    computedNativeType: function computedNativeType() {
      if (this.tag === 'a') {
        return;
      }

      return this.nativeType;
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    _vm.computedTag,
    _vm._g(
      _vm._b(
        {
          tag: "component",
          class: _vm.rootClasses,
          attrs: { type: _vm.computedNativeType }
        },
        "component",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.iconLeft
        ? _c("o-icon", {
            attrs: {
              pack: _vm.iconPack,
              icon: _vm.iconLeft,
              size: _vm.size,
              both: _vm.iconBoth
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.label
        ? _c("span", [_vm._v(_vm._s(_vm.label))])
        : _vm.$slots.default
        ? _c("span", [_vm._t("default")], 2)
        : _vm._e(),
      _vm._v(" "),
      _vm.iconRight
        ? _c("o-icon", {
            attrs: {
              pack: _vm.iconPack,
              icon: _vm.iconRight,
              size: _vm.size,
              both: _vm.iconBoth
            }
          })
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export { __vue_component__ as _ };
